<template>
	<LayoutTableCommonRow>
		<LayoutTableCommonPartText :text="customer.name" :subtext="subtext" :header="dateFormatted" @select="select">
			<template #extras>
				<CustomerCommonStatusInfo :customer_user="customer.active_user?.pivot" />
			</template>
		</LayoutTableCommonPartText>
		<LayoutTableCommonPartRaw class="text-center px-2" width="35" @select="select">
			<input type="checkbox" :checked="(selecteds.type == 'all' || selecteds.ids.includes(customer.id))" :disabled="selecteds.type == 'all'" class="form-check-input">
		</LayoutTableCommonPartRaw>
		<LayoutTableCommonPartInfo :info="extras" />
		<LayoutTableCommonPartRaw class="text-end" width="100">
			<button type="button" class="btn btn-xs btn-neutral rounded-pill" @click="contact">Contactar</button>
		</LayoutTableCommonPartRaw>
	</LayoutTableCommonRow>
</template>

<script>
	import { computed, getCurrentInstance } from 'vue';
	import moment from 'moment';

	export default {
		emits: ['select'],
		props: {
			customer: Object,
			selecteds: Object
		},
		setup(props, { emit }) {
			const instance = getCurrentInstance();
			const dateFormatted = computed(() => moment(props.customer.created_at).format('DD/MM/YYYY'));
			const contact = () => instance.proxy.$customerContact(props.customer);
			const select = () => emit('select', props.customer);

			const subtext = computed(() => {
				let data = [];

				data.push((!props.customer.group) ? 'Sin grupo asignado' : props.customer.group.name);
				data.push((!props.customer.active_user) ? 'Sin vendedor asignado' : props.customer.active_user.name);

				return data.join(' · ');
			});

			const extras = computed(() => {
				let data = [];

				if('last_buy' in props.customer.extras) {
					data.push(`<b>Última compra:</b> ${moment(props.customer.extras.last_buy).fromNow()}`);
				}

				if('total_buy' in props.customer.extras) {
					let numberFormat = new Intl.NumberFormat('es-ES');
					data.push(`<b>Compra total:</b> $ ${numberFormat.format(props.customer.extras.total_buy)}`);
				}

				if('birthdate' in props.customer.extras) {
					data.push(`<b>Cumpleaños:</b> ${moment(props.customer.extras.birthdate).format('dddd D [de] MMMM')}`);
				}

				if('group' in props.customer && props.customer.group) {
					data.push(`<b>Grupo:</b> ${props.customer.group.name}`);
				}

				if(data.length == 0) {
					data.push('Sin información adicional');
				}

				return data.join('<br />');
			});

			return { dateFormatted, contact, select, subtext, extras };
		}
	}
</script>